import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid } from '@material-ui/core'
import {
    ButtonHLPure,
    TextAreaHLPure,
    SearchBarHLPure,
    DialogSystemGLPure,
    SubtitlePageHLPure,
    CheckBoxHLPure,
} from '../../pures'
import { ClientCompanyService } from '../../../services'
import './business-administration-categories.css'

const BusinessAdministrationCategoriesView = ({
    hideShowDetails,
    toggleCompleted,
    selectedUser,
    token,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showWarningRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    toggleErrorRequesting,
    toggleWarningRequesting,
    message
}) => {
    const { t } = useTranslation()
    const [categoriesByCompany, setCategoriesByCompany] = useState([])
    const [categoriesFiltered, setCategoriesFiltered] = useState([])
    const [searchValue, setSearchValue] = useState('')
    let clientCompanyService = new ClientCompanyService(process.env.REACT_APP_MIFIRMA_API)


    const getCategoriesByCompany = async () => {
        toggleLoadingRequesting(true)
        try {
            let res = await clientCompanyService.getCategoriesByCompany(selectedUser.companyId, token)
            if (res.data && res.data.length > 0) {
                setCategoriesByCompany([...res.data])
                setCategoriesFiltered([...res.data])
                toggleLoadingRequesting(false)
            } else if (res.statusCode === -1) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 'La empresa no existe en Bóveda Digital. Por favor contacte a soporte técnico: soporte@govo.digital')
                setTimeout(() => {
                    hideShowDetails()
                    toggleErrorRequesting(false)
                }, 3000)
            } else {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true)
                setTimeout(() => {
                    hideShowDetails()
                    toggleErrorRequesting(false)
                }, 3000)
            }
        } catch (e) {
            console.log(e)
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true)
            setTimeout(() => {
                hideShowDetails()
                toggleErrorRequesting(false)
            }, 3000)
        }
    }
    const handleUpdateCatgories = async () => {
        const isEqual = JSON.stringify(categoriesByCompany) === JSON.stringify(categoriesFiltered)
        if (isEqual) {
            toggleWarningRequesting(true, 'No se ha modificado ninguna categoría')
        } else {
            toggleLoadingRequesting(true)
            let newArray = []
            categoriesByCompany.map((cat) => {
                let keyToCompare = categoriesFiltered.find(item => item.key === cat.key)
                if (keyToCompare !== cat) {
                    newArray.push({ key: cat.key, active: keyToCompare.active })
                }
            })
            let res = await clientCompanyService.createCategoryCompany(selectedUser.companyId, newArray, token)
            if (res.statusCode === 200) {
                toggleLoadingRequesting(false)
                toggleCompleted(true)
                setTimeout(() => {
                    hideShowDetails()
                }, 3000)
            } else if (res.statusCode === -1) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 'La compañía no existe en Bóveda Digital')
            } else {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, '')
            }
        }
    }
    const handleCheckbox = (e, item) => {
        let forChange = [...categoriesFiltered.map((cat) => {
            if (cat.key === item.key && e.target.checked) {
                return { ...cat, active: e.target.checked }
            } else if (cat.key === item.key && !e.target.checked) {
                return { ...cat, active: e.target.checked }
            }
            return cat
        })]
        setCategoriesFiltered(forChange)
    }

    useEffect(() => {
        getCategoriesByCompany(selectedUser.companyId, token)
    }, [])

    useEffect(() => {
        let categoriesCopy = [...categoriesByCompany]
        let dataUpadate = categoriesCopy.filter((category) =>
            category.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            category.name.includes(searchValue.toLowerCase())
        )
        setCategoriesFiltered(dataUpadate)
    }, [searchValue])

    return (
        <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className='userAdministrationAddNewUserView-wrapper'
        >
            <>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xs={12}
                    sm={12}
                    className='businessAdministrationCategoriesView-header'
                >
                    <SubtitlePageHLPure
                        subtitle={
                            t('businessAdministrationPanelView.categories') +
                            ' para ' + selectedUser.companyName
                        }
                    // handleChangeImage={handleChangeImgProfile}
                    />
                </Grid>
                <Grid
                    container
                    className='businessAdministrationCategoriesView-body'
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                >
                    <>
                        {/*Container primera seccion de items, fila*/}
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className='businessAdministrationCategoriesView-form'
                        >
                            <Grid
                                item
                                className='businessAdministrationCategoriesView-searchBar'
                            >
                                <SearchBarHLPure
                                    onSearchChange={(e) => setSearchValue(e.target.value)}
                                    placeholder={'Buscar categorías'}
                                    searchValue={searchValue}
                                    style={{ width: '50vw' }}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className='businessAdministrationCategoriesView-checkboxContainer'
                        >
                            {categoriesFiltered.length > 0 ?
                                categoriesFiltered.map((category) => {
                                    return (
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className='businessAdministrationCategoriesView-categories'
                                        >
                                            <CheckBoxHLPure
                                                titleTooltip={'Categoria con archivos'}
                                                descriptionTooltip={'La categoría no puede eliminarse porque contiene archivos en la misma categoría y/o en una subcategoría'}
                                                positionTooltip={'right'}
                                                informationIcon
                                                tooltipShow={category.block}
                                                disabled={category.block}
                                                checkedState={category.active}
                                                onChangeHandler={(e) => handleCheckbox(e, category)}
                                                valueCheckBox={category.key}
                                                labelCheckBox={category.name} />
                                        </Grid>
                                    )
                                })
                                : null}
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className='businessAdministrationCategoriesView-btnGroup'
                        >
                            <div
                                xs={12}
                                className='businessAdministrationCategoriesView-spaceBtns'
                            >
                                <ButtonHLPure
                                    primary={false}
                                    nameBtn={'Regresar'}
                                    onClickBtn={hideShowDetails}
                                />
                            </div>
                            <ButtonHLPure
                                primary
                                onClickBtn={() => handleUpdateCatgories()}
                                nameBtn={
                                    'Asignar categorías'
                                }
                            />
                        </Grid>
                    </>
                </Grid>
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    showCompletedRequesting={showCompletedRequesting}
                    showErrorRequesting={showErrorRequesting}
                    showWarningRequesting={showWarningRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    toggleWarningRequesting={toggleWarningRequesting}
                    message={message}
                />
            </>
        </Grid>
    )
}

export default BusinessAdministrationCategoriesView
